import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import ServicePriceTable from './../../PriceTables/ServicePriceTable';
import PricingService from './../../../services/PricingService';
import SubmitButton from '../../_shared/SubmitButton';

class CustomerPrices extends Component {
    constructor(props) {
        super(props);

        let {
            jobTypes,
            jobExtras,
            tyreTypes,
            gardeningExtras,
            wasteBagExtras,
            skipHireExtras,
            sorCodes,
            sorExtras,
            customer,
        } = this.props;

        /*Compare customer_priceables and job_types, if customer_priceables field is missing use job_types field and default values */
        if (customer.job_types.length > 0) {
            jobTypes = jobTypes.map((el) => {
                let pricing_field = customer.job_types.find((element) => {
                    return element.priceable_id === el.id;
                });
                return pricing_field ? pricing_field : el;
            });
        }

        if (customer.job_extras.length > 0) {
            jobExtras = jobExtras.map((el) => {
                let pricing_field = customer.job_extras.find((element) => {
                    return element.priceable_id === el.id;
                });
                return pricing_field ? pricing_field : el;
            });
        }
        if (customer.tyre_types.length > 0) {
            tyreTypes = tyreTypes.map((el) => {
                let pricing_field = customer.tyre_types.find((element) => {
                    return element.priceable_id === el.id;
                });
                return pricing_field ? pricing_field : el;
            });
        }

        if (customer.gardening_extras.length > 0) {
            gardeningExtras = gardeningExtras.map((el) => {
                let pricing_field = customer.gardening_extras.find((element) => {
                    return element.priceable_id === el.id;
                });
                return pricing_field ? pricing_field : el;
            });
        }

        if (customer.waste_bag_extras.length > 0) {
            wasteBagExtras = wasteBagExtras.map((el) => {
                let pricing_field = customer.waste_bag_extras.find((element) => {
                    return element.priceable_id === el.id;
                });
                return pricing_field ? pricing_field : el;
            });
        }

        if (customer.skip_hire_extras.length > 0) {
            skipHireExtras = skipHireExtras.map((el) => {
                let pricing_field = customer.skip_hire_extras.find((element) => {
                    return element.priceable_id === el.id;
                });
                return pricing_field ? pricing_field : el;
            });
        }

        if (customer.sor_codes.length > 0) {
            sorCodes = sorCodes.map((el) => {
                let pricing_field = customer.sor_codes.find((element) => {
                    return element.priceable_id === el.id;
                });
                return pricing_field ? pricing_field : el;
            });
        }

        if (customer.sor_extras.length > 0) {
            sorExtras = sorExtras.map((el) => {
                let pricing_field = customer.sor_extras.find((element) => {
                    return element.priceable_id === el.id;
                });
                return pricing_field ? pricing_field : el;
            });
        }
        this.state = {
            jobExtras: jobExtras,
            jobTypes: jobTypes,
            tyreTypes: tyreTypes,
            gardeningExtras: gardeningExtras,
            wasteBagExtras: wasteBagExtras,
            skipHireExtras: skipHireExtras,
            sorCodes: sorCodes,
            sorExtras: sorExtras,
            model: 'customer',
            loading: false,
            showSuccessToast: false,
            showErrorToast: false,
            errors: {
                jobTypes: [],
                jobExtras: [],
                tyreTypes: [],
                gardeningExtras: [],
                wasteBagExtras: [],
                skipHireExtras: [],
                sorCodes: [],
                sorExtras: [],
            },
        };
        this.pricingService = new PricingService();

        this.handleJobExtrasChange = this.handleJobExtrasChange.bind(this);
        this.mapInputsToFormData = this.mapInputsToFormData.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleJobExtrasChange(target, id, table) {
        let extras = this.state[table].slice().map((extra) => {
            return { ...extra };
        });

        let input = target.type;

        extras.map((obj) => {
            if (obj.id === id) {
                //check if input['number'] or checkbox is changed
                if (input === 'number') {
                    obj[target.name] = target.value;
                } else {
                    obj.available = !obj.available;
                }
            }
        });

        this.setState({ [table]: extras });
    }

    checkIfEmptyFields = (extras, type, errors) => {
        let type_errors = { ...errors };
        extras.forEach((extra) => {
            if (extra.available == false) {
                return;
            }
            if (extra.default_price === '') {
                errors[type] = [...errors[type], { id: extra.id, default_price: 'Default price is required' }];
            }

            if (extra.waste_journey_fee !== 'undefined' && extra.waste_journey_fee === '') {
                let row = errors[type].findIndex((el) => el.id === extra.id);
                if (row > -1) {
                    errors[type][row] = { ...errors[type][row], waste_journey_fee: 'Wasted journey fee is required' };
                } else {
                    errors[type] = [
                        ...errors[type],
                        { id: extra.id, waste_journey_fee: 'Wasted journey fee is required' },
                    ];
                }
            }
        });

        return type_errors;
    };

    validateForm = () => {
        let valid = true;
        let errors = {
            jobTypes: [],
            jobExtras: [],
            tyreTypes: [],
            gardeningExtras: [],
            wasteBagExtras: [],
            skipHireExtras: [],
            sorCodes: [],
            sorExtras: [],
        };

        //Check if there is empty field in job types
        errors = this.checkIfEmptyFields(this.state.jobTypes, 'jobTypes', errors);

        //check if there is empty fields in job extras
        errors = this.checkIfEmptyFields(this.state.jobExtras, 'jobExtras', errors);

        //check if there is empty fields in tyre types
        errors = this.checkIfEmptyFields(this.state.tyreTypes, 'tyreTypes', errors);

        //check if there is empty fields in gardening extras
        errors = this.checkIfEmptyFields(this.state.gardeningExtras, 'gardeningExtras', errors);

        //check if there is empty fields in waste bag extras
        errors = this.checkIfEmptyFields(this.state.wasteBagExtras, 'wasteBagExtras', errors);

        //check if there is empty fields in skip hire extra
        errors = this.checkIfEmptyFields(this.state.skipHireExtras, 'skipHireExtras', errors);

        //check if there is empty fields in sor codes
        errors = this.checkIfEmptyFields(this.state.sorCodes, 'sorCodes', errors);

        //check if there is empty fields in sor extras
        errors = this.checkIfEmptyFields(this.state.sorExtras, 'sorExtras', errors);

        if (
            errors.jobTypes.length > 0 ||
            errors.jobExtras.length > 0 ||
            errors.tyreTypes.length > 0 ||
            errors.gardeningExtras.length > 0 ||
            errors.wasteBagExtras.length ||
            errors.skipHireExtras.length > 0 ||
            errors.sorExtras.length > 0 ||
            errors.sorCodes.length > 0
        ) {
            valid = false;
            this.setState({
                errors: errors,
            });
        }
        return valid;
    };

    mapInputsToFormData = () => {
        let formData = new FormData();

        this.state.jobTypes.forEach((jobType) =>
            formData.append(
                'jobTypes[]',
                JSON.stringify({
                    customer_priceables_id: jobType.id,
                    price: jobType.default_price,
                    available: jobType.available,
                    waster_journey_fee: jobType.waster_journey_fee,
                    custom_sla: jobType.custom_sla ? jobType.custom_sla : this.props.customer.sla,
                })
            )
        );
        this.state.jobExtras.forEach((jobExtra) =>
            formData.append(
                'jobExtras[]',
                JSON.stringify({
                    customer_priceables_id: jobExtra.id,
                    price: jobExtra.default_price,
                    available: jobExtra.available,
                })
            )
        );
        this.state.tyreTypes.forEach((tyreType) =>
            formData.append(
                'tyreTypes[]',
                JSON.stringify({
                    customer_priceables_id: tyreType.id,
                    price: tyreType.default_price,
                    available: tyreType.available,
                })
            )
        );
        this.state.gardeningExtras.forEach((gardeningExtra) =>
            formData.append(
                'gardeningExtras[]',
                JSON.stringify({
                    customer_priceables_id: gardeningExtra.id,
                    price: gardeningExtra.default_price,
                    available: gardeningExtra.available,
                })
            )
        );
        this.state.wasteBagExtras.forEach((wasteBagExtra) =>
            formData.append(
                'wasteBagExtras[]',
                JSON.stringify({
                    customer_priceables_id: wasteBagExtra.id,
                    price: wasteBagExtra.default_price,
                    available: wasteBagExtra.available,
                })
            )
        );
        this.state.skipHireExtras.forEach((skipHireExtra) =>
            formData.append(
                'skipHireExtras[]',
                JSON.stringify({
                    customer_priceables_id: skipHireExtra.id,
                    price: skipHireExtra.default_price,
                    available: skipHireExtra.available,
                })
            )
        );
        this.state.sorCodes.forEach((sorCode) =>
            formData.append(
                'sorCodes[]',
                JSON.stringify({
                    customer_priceables_id: sorCode.id,
                    price: sorCode.default_price,
                    available: sorCode.available,
                })
            )
        );
        this.state.sorExtras.forEach((sorExtra) =>
            formData.append(
                'sorExtras[]',
                JSON.stringify({
                    customer_priceables_id: sorExtra.id,
                    price: sorExtra.default_price,
                    available: sorExtra.available,
                })
            )
        );
        return formData;
    };

    handleSubmit(e) {
        e.preventDefault();

        if (this.validateForm()) {
            this.setState({ loading: true });

            const formData = this.mapInputsToFormData();

            if (this.props.buttonText === 'Create') {
                this.pricingService
                    .saveCustomerPricing(this.props.customer, formData)
                    .then((res) => {
                        //  Stop spinner flag
                        this.setState({ loading: false });
                        toastr.success('Prices successfully saved');
                    })
                    .catch(() => {
                        //  Stop spinner flag
                        this.setState({ loading: false });
                        toastr.error('There was a problem with submitting the form. Please try again.');
                    });
            } else {
                formData.append('_method', 'PATCH');
                this.pricingService
                    .updateCustomerPricing(this.props.customer, formData)
                    .then((res) => {
                        //  Stop spinner flag
                        this.setState({ loading: false });
                        toastr.success('Prices successfully saved');
                    })
                    .catch(() => {
                        //  Stop spinner flag
                        this.setState({ loading: false });
                        toastr.error('There was a problem with submitting the form. Please try again.');
                    });
            }
        }
    }

    render() {
        return (
            <form className="customer-pricing-form" onSubmit={this.handleSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <ServicePriceTable
                            heading="Job Types Prices"
                            tableTypes={this.state.jobTypes}
                            customerSla={this.props.customer.sla}
                            table="jobTypes"
                            handleJobExtrasChange={this.handleJobExtrasChange}
                            model={this.state.model}
                            errors={this.state.errors.jobTypes}
                            readOnly={this.props.readOnly}
                        />
                    </div>
                    <div className="col-md-6">
                        <ServicePriceTable
                            heading="Job Extras Prices"
                            table="jobExtras"
                            tableTypes={this.state.jobExtras}
                            handleJobExtrasChange={this.handleJobExtrasChange}
                            model={this.state.model}
                            errors={this.state.errors.jobExtras}
                            readOnly={this.props.readOnly}
                        />
                        <ServicePriceTable
                            heading="Tyre Types Prices"
                            tableTypes={this.state.tyreTypes}
                            table="tyreTypes"
                            handleJobExtrasChange={this.handleJobExtrasChange}
                            model={this.state.model}
                            errors={this.state.errors.tyreTypes}
                            readOnly={this.props.readOnly}
                        />
                    </div>
                    <div className="col-md-6">
                        <ServicePriceTable
                            heading="Gardening Extras Prices"
                            tableTypes={this.state.gardeningExtras}
                            table="gardeningExtras"
                            handleJobExtrasChange={this.handleJobExtrasChange}
                            model={this.state.model}
                            errors={this.state.errors.gardeningExtras}
                            readOnly={this.props.readOnly}
                        />
                        <ServicePriceTable
                            heading="Waste Bag Extras Prices"
                            tableTypes={this.state.wasteBagExtras}
                            table="wasteBagExtras"
                            handleJobExtrasChange={this.handleJobExtrasChange}
                            model={this.state.model}
                            errors={this.state.errors.wasteBagExtras}
                            readOnly={this.props.readOnly}
                        />
                    </div>
                    <div className="col-md-6">
                        <ServicePriceTable
                            heading="Sor Codes Prices"
                            tableTypes={this.state.sorCodes}
                            table="sorCodes"
                            handleJobExtrasChange={this.handleJobExtrasChange}
                            model={this.state.model}
                            errors={this.state.errors.sorCodes}
                            readOnly={this.props.readOnly}
                        />
                    </div>
                    <div className="col-md-6">
                        <ServicePriceTable
                            heading="Sor Extras Prices"
                            tableTypes={this.state.sorExtras}
                            table="sorExtras"
                            handleJobExtrasChange={this.handleJobExtrasChange}
                            model={this.state.model}
                            errors={this.state.errors.sorExtras}
                            readOnly={this.props.readOnly}
                        />
                        <ServicePriceTable
                            heading="Skip Hire Extras Prices"
                            tableTypes={this.state.skipHireExtras}
                            table="skipHireExtras"
                            handleJobExtrasChange={this.handleJobExtrasChange}
                            model={this.state.model}
                            errors={this.state.errors.skipHireExtras}
                            readOnly={this.props.readOnly}
                        />
                    </div>
                </div>
                {!this.props.readOnly ? (
                    <div className="row">
                        <div className="col-12">
                            <SubmitButton
                                buttonText={this.props.buttonText}
                                loading={this.state.loading}
                                style={{ width: 200, marginTop: 50 }}
                            />
                        </div>
                    </div>
                ) : null}
            </form>
        );
    }
}

if (document.getElementById('customerPrices')) {
    let element = document.getElementById('customerPrices');
    ReactDOM.render(
        <CustomerPrices
            jobTypes={JSON.parse(element.dataset.job_types)}
            jobExtras={JSON.parse(element.dataset.job_extras)}
            tyreTypes={JSON.parse(element.dataset.tyre_types)}
            gardeningExtras={JSON.parse(element.dataset.gardening_extras)}
            wasteBagExtras={JSON.parse(element.dataset.waste_bag_extras)}
            skipHireExtras={JSON.parse(element.dataset.skip_hire_extras)}
            sorCodes={JSON.parse(element.dataset.sor_codes)}
            sorExtras={JSON.parse(element.dataset.sor_extras)}
            customer={JSON.parse(element.dataset.customer)}
            buttonText={JSON.parse(element.dataset.button_text)}
            readOnly={JSON.parse(element.dataset.read_only)}
        />,
        element
    );
}
